import { Link } from 'react-router';
import ActionLink from '../../../../Components/Dashboard/ActionLink';
import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { ACTIVE_USERS_DESCRIPTION, ACTIVE_USERS_TITLE } from './activeUsersCopy';
import styles from '../adminCards.module.css';

const LIMIT = 10;

const fullName = row => [row.firstName, row.lastName].filter(Boolean).join(' ') || '—';
const athletesText = n => `${n} ${n === 1 ? 'athlete' : 'athletes'}`;

/** Admin-only: active (not Inactive) coaches and their Active athletes; every total is scoped to active coaches. */
const ActiveUsersCard = () => {
    const { status, data, error, reload } = useAsync(() => API.getAdminActiveUsers({ limit: LIMIT }).then(res => res.data), []);

    let body;
    let foot;
    if (status === 'loading' && !data) body = <CardLoading label={ACTIVE_USERS_TITLE} />;
    else if (status === 'error') body = <CardError label={ACTIVE_USERS_TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (data) {
        const { items, totals, truncated } = data;
        body = (
            <>
                <p className={styles.auDesc}>
                    {ACTIVE_USERS_DESCRIPTION}
                </p>
                {items.length === 0 ? (
                    <CardEmpty>No active coaches yet.</CardEmpty>
                ) : (
                    <>
                        <dl className={styles.auStats}>
                            <div>
                                <dt>Active coaches</dt>
                                <dd>{totals.coaches}</dd>
                            </div>
                            <div>
                                <dt>Athletes managed by active coaches</dt>
                                <dd>{totals.athletesManaged}</dd>
                            </div>
                            <div>
                                <dt>Not linked to an active coach</dt>
                                <dd>{totals.unlinkedAthletes}</dd>
                            </div>
                        </dl>
                        <ul className={styles.list}>
                            {items.map(row => (
                                <li key={row.id}>
                                    <div className={styles.auRow}>
                                        <Link className={styles.auName} to={`/coach/${encodeURIComponent(row.id)}/coach_dashboard`} title={fullName(row)}>
                                            {fullName(row)}
                                        </Link>
                                        <span className={styles.auCount}>
                                            <span className={styles.auSr}>Athletes managed: </span>
                                            {athletesText(row.athleteCount)}
                                        </span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </>
        );
        if (truncated)
            foot = (
                <>
                    <span>
                        Showing {items.length} of {totals.coaches} coaches
                    </span>
                    <ActionLink to="/users">User Management</ActionLink>
                </>
            );
    }

    return (
        <Card id="au" module="admin-active-users" title={ACTIVE_USERS_TITLE} busy={status === 'loading'} flush foot={foot}>
            {body}
        </Card>
    );
};

export default ActiveUsersCard;
